import React, { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  Input,
  CircularProgress,
  Backdrop,
  Paper
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import { baseUrl, departments } from '../../utils/constants';
import { useAccountingContext } from '../../context/accounting_context';

/* eslint-disable camelcase */
function JnrAnalysisLine(props) {
  const { refId, currentAnalysis, getAnalysisDetailsById } = useAccountingContext();
  const { closePopup, claim_ID } = props;
  const [docSearchCode, setSearchCode] = useState('');
  const [docSearchName, setSearchName] = useState('');
  const [loading, setLoading] = useState(false);
  const [tariffSearchName, setTariffName] = useState('');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const JnrAnalysisLineSchema = Yup.object().shape({
    // amtClaimed: Yup.number().required('Charged Amount is Required')
  });

  const formik = useFormik({
    initialValues: currentAnalysis,
    enableReinitialize: true,
    validationSchema: JnrAnalysisLineSchema,
    onSubmit: (values) => {
      values.journalRefId = refId;
      console.log('Analysis line details ', values);
      saveAnalysisDetails(values);
    }
  });

  const saveAnalysisDetails = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('Analysis line b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/saveAnalysisDetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('Analysis detail save result', result);
          notifyPopup(`Analysis Detail Saved Successfully!`, 'success');
          getAnalysisDetailsById(refId);
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving Analysis Line Detail!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const getProviderInfo = async (event) => {
    if (docSearchCode === '') {
      notifyPopup(`No AHFOZ # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetProvider?namasNo=${docSearchCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned doc', result);
          formik.setFieldValue('namasNo', result.data.namasNo);
          formik.setFieldValue('creditor', result.data.provider_id);
          setSearchName(result.data.provider);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Medical Practise!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid item xs={12} sm={12}>
            <Paper margin={10}>
              <Grid item xs={6} sm={6} margin={2}>
                <FormControl>
                  <InputLabel htmlFor="docSearchCode">Search Provider</InputLabel>
                  <Input
                    id="docSearchCode"
                    type="text"
                    value={docSearchCode}
                    onChange={(e) => {
                      setSearchCode(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onMouseDown={handleMouseDownPassword}
                          onClick={() => getProviderInfo()}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={3} sm={3}>
            <Controls.Input name="creditor" label="Doctor Code" disabled />
          </Grid>
          <Grid item xs={3} sm={3}>
            <Controls.Input name="namasNo" label="AHFOZ #" disabled />
          </Grid>
          <Grid item xs={9} sm={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="docSearchName">Provider Name</InputLabel>
              <Input id="docSearchName" type="text" value={docSearchName} disabled />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.Input name="claimNo" label="Claim #" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.Input name="membershipNo" label="Membership #" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="debitAward" label="Debit Award" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="creditAward" label="Credit Award" disabled />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={formik.values.treatmentDate === '' || formik.values.tarrif_id === 0}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default JnrAnalysisLine;
